module.exports = __webpack_public_path__ + "static/media/sessions.8be826b0.svg";